import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {Link} from '@/i18n/routing';
import AddToCartButton from '../design-system/AddToCartButton';
import {Price} from '../design-system/Price';
import ProductItemThumb from './ProductItemThumb';

interface IProps {
  product: SearchProduct;
  isShowOnly?: boolean;
  button?: any; // React Fragment?
  hidePrice?: boolean;
}

const ProductItemMobile = ({
  product,
  isShowOnly,
  button,
  hidePrice = false,
}: IProps) => {
  return (
    <div className="product-item product-card py-3">
      <div className="flex flex-wrap">
        <div className="w-5/12 flex flex-col justify-start">
          {
            <ProductItemThumb
              product={product}
              wishListButton={!isShowOnly}
            />
          }
        </div>
        <div className="w-7/12 flex flex-col justify-between">
          <div>
            <h3 className="text-left font-medium mb-2">
              {isShowOnly ? (
                <a>{product.name}</a>
              ) : (
                <Link
                  href={{
                    pathname: '/shop/[id]',
                    params: {id: product.slug!},
                  }}
                >
                  {product.name}
                </Link>
              )}
            </h3>

            <h4 className="text-left capitalize leading-3 text-greyscale-gray-dark font-normal m-0 text-sm">
              {product.producer}
            </h4>
            {!hidePrice && (
              <h4 className="m-0 text-xl text-greyscale-gray-dark font-normal text-left">
                <Price
                  price={product.price}
                  discountedPrice={product.discountedPrice}
                />
              </h4>
            )}
          </div>
          {button ? button : <AddToCartButton product={product} />}
        </div>
      </div>
    </div>
  );
};

export default ProductItemMobile;
